import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PrinterState {
  /** Last paired Bluetooth device id (browser opaque), so we can show "reconnect" hint. */
  pairedDeviceName: string | null;
  /** Auto-send receipt to the connected BT printer when an order is completed. */
  autoPrint: boolean;
  /** Receipt paper width (58mm = compact, 80mm = standard). Used by both BT ESC/POS and CSS. */
  paperWidth: 58 | 80;
  setPaired: (name: string | null) => void;
  setAutoPrint: (on: boolean) => void;
  setPaperWidth: (w: 58 | 80) => void;
}

const DEFAULTS = {
  pairedDeviceName: null as string | null,
  autoPrint: false,
  paperWidth: 58 as 58 | 80,
};

export const usePrinterStore = create<PrinterState>()(
  persist(
    (set) => ({
      ...DEFAULTS,
      setPaired: (pairedDeviceName) => set({ pairedDeviceName }),
      setAutoPrint: (autoPrint) => set({ autoPrint }),
      setPaperWidth: (paperWidth) => set({ paperWidth }),
    }),
    {
      name: 'hoopla-pos:printer',
      version: 1,
      // Defensive: future field additions won't wipe paired printer or auto-print.
      migrate: (persisted) => {
        const prev = (persisted ?? {}) as Partial<PrinterState>;
        return { ...DEFAULTS, ...prev };
      },
    },
  ),
);
